import {LEAD_ID_STORAGE_KEY} from 'src/common/constants'
import {safeParse} from 'src/common/helpers'

export const setLeadId = (leadId: string) => localStorage.setItem(LEAD_ID_STORAGE_KEY, JSON.stringify(leadId))

export const getLeadId = (): string | null => {
  if (typeof window === 'undefined') {
    return null
  }

  const storedLeadId = localStorage.getItem(LEAD_ID_STORAGE_KEY)

  if (storedLeadId) {
    return safeParse(storedLeadId)
  }

  return null
}

export const urlIncludes = (target: {url?: string} | null | undefined, searchStrings: string | string[]): boolean => {
  const url = target?.url

  if (typeof url !== 'string') {
    return false
  }

  const searches = Array.isArray(searchStrings) ? searchStrings : [searchStrings]

  return searches.some((search) => url.includes(search))
}
